import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {store} from "../src/redux/store";
import {HelmetProvider} from "react-helmet-async";

import {Provider} from "react-redux";

import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={store}>
		<React.StrictMode>
			<HelmetProvider>
				{/* <BrowserRouter basename={process.env.NODE_ENV === "production" ? process.env.PUBLIC_URL : ""}> */}
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</HelmetProvider>
		</React.StrictMode>
	</Provider>
);
